import PropTypes from "prop-types";
import classNames from "classnames";

const IconBack = ({ size = 16, className, ...props }) => {
	const iconBackClassName = classNames("icon-back flip-if-rlt", {
		[className]: className,
	});

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			className={iconBackClassName}
			{...props}
		>
			<path
				d="M15.2954 4.70528C15.6847 5.09458 15.685 5.72568 15.296 6.11528L9.42018 12L15.296 17.8847C15.685 18.2743 15.6847 18.9054 15.2954 19.2947C14.9059 19.6843 14.2744 19.6843 13.8849 19.2947L7.29729 12.7071C6.90676 12.3166 6.90676 11.6834 7.29729 11.2929L13.8849 4.70528C14.2744 4.31577 14.9059 4.31577 15.2954 4.70528Z"
				fill="currentColor"
			/>
		</svg>
	);
};

IconBack.propTypes = {
	size: PropTypes.number,
	className: PropTypes.string,
};

export default IconBack;
